<template>
  <div class="ourcontainer alertcontainer">
    <div
      class="alert"
      :class="{error: type==='error', message: type==='message'}"
      role="alert"
    >
      <p>{{ content }}</p>
    </div>
  </div>
</template>

<script>
export default {
    props: ['content', 'type'],
}
</script>

<style lang="scss" scoped>
.alert {
    @include mc-tooltip;
    max-width: min(50rem, 100%);
    text-align: center;
    color: $color-white;
}

.error {
    @include mc-frame($ssm-redstone);
}

.message {
    @include mc-frame($ssm-gold);
}

p {
    margin: 0.75rem 1rem;
    word-wrap: break-word;
}

.alertcontainer {
    display: flex;
    justify-content: center;
    margin: 1rem 1rem 0;
}
</style>
